import { Directive, EventEmitter, Input, Output, ViewContainerRef, ElementRef } from '@angular/core';

import { SgClickConfirmOptions, SgClickConfirmPluginContext } from './types';
import { SgClickConfirmPluginHost } from './click-confirm.service';

@Directive({
  selector: '[sgClickConfirm]',
  host: { '(click)': 'onClick($event)' },
  standalone: false,
})
export class SgClickConfirmDirective {
  @Output('sgClickConfirm') clickConfirm = new EventEmitter<MouseEvent>();

  /**
   * Extra configuration options for opening the confirm box.
   * Can accept a static object or a functin returning SgClickConfirmOptions which allows dynamic options bindings.
   *
   * Note that SgClickConfirmOptions might be extended by plugins and include additional properties.
   */
  @Input() confirmOptions: SgClickConfirmOptions | ((...args: any[]) => SgClickConfirmOptions);

  /**
   * Optional parameters to use when calling `confirmOptions`.
   * Valid only when `confirmOptions` is a function.
   */
  @Input() confirmOptionsParams: any | any[];

  constructor(
    private vcRef: ViewContainerRef,
    private elRef: ElementRef,
    private pluginHost: SgClickConfirmPluginHost
  ) {}

  onClick(event: MouseEvent): void {
    let confirmOptions: SgClickConfirmOptions;
    if (typeof this.confirmOptions === 'function') {
      const params = Array.isArray(this.confirmOptionsParams)
        ? this.confirmOptionsParams
        : this.confirmOptionsParams
          ? [this.confirmOptionsParams]
          : [];
      confirmOptions = this.confirmOptions(...params);
    } else {
      confirmOptions = this.confirmOptions;
    }

    if (confirmOptions.stopPropagation) {
      event.stopPropagation();
    }

    const ctx: SgClickConfirmPluginContext = {
      vcRef: this.vcRef,
      elRef: this.elRef,
      options: confirmOptions || <any>{},
      component: undefined, // pluginHost.createContext() will handle this
      confirm: (value) => {
        if (value) {
          this.clickConfirm.emit(event);
        }
      },
    };
    this.pluginHost.plugin(ctx.options.style).open(event, this.pluginHost.createContext(ctx));
  }
}
